export default {
  INITIAL: 'initial',
  PLAYING: 'playing',
  PAUSED: 'paused',
  ENDED: 'ended',
};



// WEBPACK FOOTER //
// ./src/widget/constants/video-playback-status.js